import * as React from 'react';
import { Switch } from 'react-router-dom';

// tslint:disable-next-line:no-unused-variable
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Zone from './zone';
import Pricing from './pricing';
import Session from './session';
import Site from './site';
/* jhipster-needle-add-route-import - JHipster will add routes here */

const Routes = ({ match }) => (
  <div>
    <Switch>
      {/* prettier-ignore */}
      <ErrorBoundaryRoute path={`${match.url}/zone`} component={Zone} />
      <ErrorBoundaryRoute path={`${match.url}/pricing`} component={Pricing} />
      <ErrorBoundaryRoute path={`${match.url}/session`} component={Session} />
      <ErrorBoundaryRoute path={`${match.url}/site`} component={Site} />
      {/* jhipster-needle-add-route-path - JHipster will routes here */}
    </Switch>
  </div>
);

export default Routes;
